<div class="container-scroller" *ngIf="!(router.url.includes('/landingpage')) && !(router.url.includes('/committee'))">
    <nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div class="text-left navbar-brand-wrapper d-flex align-items-center justify-content-center">
            <a [routerLink]="['/dashboard']">
                <span>
                    <!-- <img src="assets/images/logo.png" width="10%" class="mr-1"
                        style="min-width: 50px; margin-left: auto;margin-right: auto;" alt="logo" />
                    <img src="assets/images/logoss.png" width="10%" style="min-width: 50px; margin-left: auto;margin-right: auto;"
                        alt="logo" /> -->
                    <img src="assets/images/logover2.png" width="10%" class="logo_img" alt="logo" />
                </span>
            </a>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-stretch">
            <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
                <!-- <span class="mdi mdi-menu"></span> -->
            </button>
            <ul class="navbar-nav navbar-nav-right">
                <li class="nav-item nav-profile dropdown">
                    <app-header></app-header>
                </li>
            </ul>
            <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
                (click)="clickMenu()">
                <span class="mdi mdi-menu"></span>
            </button>
        </div>
    </nav>
    <div class="container-fluid page-body-wrapper">
        <nav class="sidebar sidebar-offcanvas" id="sidebar">
            <ul class="nav">
                <app-sidemenu></app-sidemenu>
            </ul>
        </nav>
        <div class="main-panel">
            <router-outlet></router-outlet>
            <app-footer></app-footer>
        </div>
    </div>
</div>

<router-outlet *ngIf="(router.url.includes('/landingpage'))"></router-outlet>

<div class="container-scroller" *ngIf="(router.url.includes('/committee'))">
    <nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div class="text-left navbar-brand-wrapper d-flex align-items-center justify-content-center">
            <a [routerLink]="['/committee/dashboard']">
                <span>
                    <!-- <img src="assets/images/logo.png" width="10%" class="mr-1"
                        style="min-width: 50px; margin-left: auto;margin-right: auto;" alt="logo" />
                    <img src="assets/images/logoss.png" width="10%" style="min-width: 50px; margin-left: auto;margin-right: auto;"
                        alt="logo" /> -->
                    <img src="assets/images/logover2.png" width="10%" class="logo_img" alt="logo" />
                </span>
            </a>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-stretch">
            <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
                <!-- <span class="mdi mdi-menu"></span> -->
            </button>
            <ul class="navbar-nav navbar-nav-right">
                <li class="nav-item nav-profile dropdown">
                    <app-header></app-header>
                </li>
            </ul>
            <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
                (click)="clickMenu()">
                <span class="mdi mdi-menu"></span>
            </button>
        </div>
    </nav>
    <div class="container-fluid page-body-wrapper">
        <app-sidebar-dashboard></app-sidebar-dashboard>
        <div class="main-panel">
            <router-outlet></router-outlet>
            <app-footer></app-footer>
        </div>
    </div>
</div>